import { OverrideInterface } from '../interfaces';
import { PAGE_WIDTH } from '../constants';

export const MuiContainer: OverrideInterface<'MuiContainer'> = {
  styleOverrides: {
    root: ({ theme }) => ({
      maxWidth: '100%',
      marginTop: '4rem',
      marginBottom: '4rem',
      padding: '0 1rem',

      [theme.breakpoints.up('lg')]: {
        maxWidth: `${PAGE_WIDTH}px`,
        marginTop: '12.5rem',
        marginBottom: '12.5rem',
        padding: '0 2.5rem',
      },
      '& p:first-of-type': {
        marginTop: 0,
        paddingTop: 0,
      },
      '& p:last-of-type': {
        marginBottom: 0,
        paddingBottom: 0,
      },
    }),
  },
};
